// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Pervasives = require("rescript/lib/js/pervasives.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Smartcut$SmartcutsMacros = require("../../bs-macros-extension/src/Smartcut.bs.js");
var Main = require("react-device-detect/main");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var SmartcutIds$SmartcutsMacros = require("../../bs-macros-extension/src/SmartcutIds.bs.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");
var StateMachine$SmartcutsMacros = require("../../bs-macros-extension/src/StateMachine.bs.js");
var LoginSmartcut$SmartcutsMacros = require("../../bs-macros-extension/src/LoginSmartcut.bs.js");
var OAuthProvider$SmartcutsMacros = require("../../bs-macros-extension/src/OAuthProvider.bs.js");
var StartPlayback$SmartcutsMacros = require("../../bs-macros-extension/src/StartPlayback.bs.js");
var Modal__WebAuth$SmartcutsMacros = require("../../bs-macros-extension/src/Modal__WebAuth.bs.js");
var PlaybackTrigger$SmartcutsMacros = require("../../bs-macros-extension/src/PlaybackTrigger.bs.js");
var ScheduledTrigger$SmartcutsMacros = require("../../bs-macros-extension/src/ScheduledTrigger.bs.js");
var PermissionAndOrigin$SmartcutsMacros = require("../../bs-macros-extension/src/PermissionAndOrigin.bs.js");
var Bg__StateMachine__Shared$SmartcutsMacros = require("../../bs-macros-extension/src/Bg/StateMachine/Bg__StateMachine__Shared.bs.js");
var Segment__TrackedQuotaWarning$SmartcutsMacros = require("./Segment__TrackedQuotaWarning.bs.js");
var ContentScript__StateMachine__Shared__Types$SmartcutsMacros = require("../../bs-macros-extension/src/ContentScript/StateMachine/ContentScript__StateMachine__Shared__Types.bs.js");

function exists(param) {
  return window.analytics.analytics !== undefined;
}

function MakeTrackerForEventWithProperties(Track) {
  var track = function (properties) {
    window.analytics.track(Track.$$event, Curry._1(Track.preparePropertiesForSegment, properties));
    
  };
  return {
          track: track
        };
}

var WithStringVisibility = {};

var TrackedInstallableSmartcutProps = {
  WithStringVisibility: WithStringVisibility
};

var TrackedInstalledSmartcutProps = {};

var TrackedVisitingFromDevice = {};

function track(properties) {
  window.analytics.track("Visit page from device", properties);
  
}

var TrackVisitingFromDevice = {
  track: track
};

function trackVisitingFromDevice(page) {
  return track({
              page: page,
              browserName: Main.browserName,
              browserVersion: Main.browserVersion,
              fullBrowserVersion: Main.fullBrowserVersion,
              isMobile: Main.isMobile,
              osName: Main.osName,
              osVersion: Main.osVersion
            });
}

var WithStringified = {};

function convertTypes(param) {
  return {
          configStep: ScheduledTrigger$SmartcutsMacros.Idiomatic.configStepToString(param.configStep),
          installedSmartcutId: param.installedSmartcutId,
          scheduledDays: ScheduledTrigger$SmartcutsMacros.Idiomatic.scheduledDaysToString(param.scheduledDays),
          nTimesInADay: ScheduledTrigger$SmartcutsMacros.Idiomatic.nTimesInADayToString(param.nTimesInADay),
          nTimesInADayCustomized: param.nTimesInADayCustomized,
          scheduledTimes: ScheduledTrigger$SmartcutsMacros.Idiomatic.scheduledTimesToString(param.scheduledTimes),
          isSettingUpScheduledTriggers: param.isSettingUpScheduledTriggers ? "true" : "false"
        };
}

var TrackedSchedulingSmartcutProps = {
  WithStringified: WithStringified,
  convertTypes: convertTypes
};

function preparePropertiesForSegment(param) {
  return {
          smartcutId: param.smartcutId,
          numCommands: param.numCommands,
          numParams: param.numParams,
          hosts: param.hosts,
          visibility: Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility),
          isOutdated: param.isOutdated,
          hasLoginSmartcut: param.hasLoginSmartcut
        };
}

function track$1(properties) {
  window.analytics.track("View Installable Smartcut", preparePropertiesForSegment(properties));
  
}

var TrackViewInstallableSmartcut = {
  track: track$1
};

function trackAttemptAcceptInvite(param) {
  window.analytics.track("Attempt to accept invite");
  
}

function trackAcceptedInvite(param) {
  window.analytics.track("Accepted invite");
  
}

function track$2(properties) {
  window.analytics.track("Error while accepting invite", properties);
  
}

var TrackFailedAttemptToAcceptInvite = {
  track: track$2
};

function trackAttemptSetPassword(param) {
  window.analytics.track("Attempt to set password");
  
}

function trackSetPassword(param) {
  window.analytics.track("Set password");
  
}

function track$3(properties) {
  window.analytics.track("Error while setting password", properties);
  
}

var TrackFailedAttemptToSetPassword = {
  track: track$3
};

function trackUserForgotPassword(param) {
  window.analytics.track("User attempt to reset password");
  
}

function trackChromeExtensionDownloadAttempt(param) {
  window.analytics.track("Attempted to Download Chrome Extension");
  
}

function track$4(properties) {
  window.analytics.track("Installed Chrome extension", properties);
  
}

var TrackChromeExtensionInstall = {
  track: track$4
};

function track$5(properties) {
  window.analytics.track("Uninstalled Chrome extension", properties);
  
}

var TrackChromeExtensionUninstall = {
  track: track$5
};

function track$6(properties) {
  window.analytics.track("Updated Chrome extension", properties);
  
}

var TrackChromeExtensionUpdate = {
  track: track$6
};

function trackChromeUpdate(param) {
  window.analytics.track("Updated Chrome");
  
}

function trackChromeSharedModuleUpdate(param) {
  window.analytics.track("Updated Chrome Shared Module");
  
}

function promptReason_encode(v) {
  if (v) {
    return ["PromptedForPlayback"];
  } else {
    return ["PromptedForRecording"];
  }
}

function promptReason_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "PromptedForPlayback" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* PromptedForPlayback */1
                  };
          }
      case "PromptedForRecording" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* PromptedForRecording */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringifyPromptReason(promptReason) {
  if (promptReason) {
    return "playback";
  } else {
    return "recording";
  }
}

function t_encode(v) {
  return Js_dict.fromArray([[
                "promptReason",
                promptReason_encode(v.promptReason)
              ]]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var promptReason = promptReason_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "promptReason"), null));
  if (promptReason.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              promptReason: promptReason._0
            }
          };
  }
  var e = promptReason._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".promptReason" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function stringify(param) {
  return "{promptReason: " + ((
            param.promptReason ? "playback" : "recording"
          ) + "}");
}

var TrackedPermissionsRejection = {
  promptReason_encode: promptReason_encode,
  promptReason_decode: promptReason_decode,
  stringifyPromptReason: stringifyPromptReason,
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify
};

var TrackedPermissionsRejectionWithStringReason = {};

function preparePropertiesForSegment$1(param) {
  return {
          promptReason: param.promptReason ? "playback" : "recording"
        };
}

function track$7(properties) {
  window.analytics.track("Rejected Chrome Permissions", preparePropertiesForSegment$1(properties));
  
}

var TrackRejectPermissions = {
  track: track$7
};

function t_encode$1(v) {
  return Js_dict.fromArray([[
                "context",
                Modal__WebAuth$SmartcutsMacros.Context.t_encode(v.context)
              ]]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var context = Modal__WebAuth$SmartcutsMacros.Context.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "context"), null));
  if (context.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              context: context._0
            }
          };
  }
  var e = context._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".context" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

var WithStringContext = {};

var TrackedViewOauthExplanationModal = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  WithStringContext: WithStringContext
};

function preparePropertiesForSegment$2(param) {
  return {
          context: Modal__WebAuth$SmartcutsMacros.Context.stringify(param.context)
        };
}

function track$8(properties) {
  window.analytics.track("View OAuth Explanation Modal", preparePropertiesForSegment$2(properties));
  
}

var TrackViewOauthExplanationModal = {
  track: track$8
};

function trackCancelOAuthExplanationModal(param) {
  window.analytics.track("Canceled OAuth Explanation Modal");
  
}

function trackInitiateOAuthConsentFlow(param) {
  window.analytics.track("Initiate OAuth Consent Flow");
  
}

function trackOAuthConsentGranted(param) {
  window.analytics.track("OAuth Consent Granted");
  
}

function trackOAuthConsentRejected(param) {
  window.analytics.track("OAuth Consent Rejected");
  
}

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "host",
                Decco.stringToJson(v.host)
              ],
              [
                "url",
                Decco.stringToJson(v.url)
              ],
              [
                "trigger",
                Decco.stringToJson(v.trigger)
              ],
              [
                "mainSmartcutId",
                Decco.optionToJson(SmartcutIds$SmartcutsMacros.smartcutId_encode, v.mainSmartcutId)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var host = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "host"), null));
  if (host.TAG === /* Ok */0) {
    var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
    if (url.TAG === /* Ok */0) {
      var trigger = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trigger"), null));
      if (trigger.TAG === /* Ok */0) {
        var mainSmartcutId = Decco.optionFromJson(SmartcutIds$SmartcutsMacros.smartcutId_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "mainSmartcutId"), null));
        if (mainSmartcutId.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    host: host._0,
                    url: url._0,
                    trigger: trigger._0,
                    mainSmartcutId: mainSmartcutId._0
                  }
                };
        }
        var e = mainSmartcutId._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".mainSmartcutId" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = trigger._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".trigger" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = url._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".url" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = host._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".host" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

var WithStringFields = {
  t_encode: t_encode$2,
  t_decode: t_decode$2
};

var TrackedStartRecording = {
  WithStringFields: WithStringFields
};

function preparePropertiesForSegment$3(param) {
  var trigger = param.trigger;
  return {
          host: param.host,
          url: param.url,
          trigger: typeof trigger === "number" ? (
              trigger !== 0 ? "Url Triggering as Smartcut" : "Browser Action"
            ) : "Record Login Smartcut",
          mainSmartcutId: typeof trigger === "number" ? undefined : Caml_option.some(trigger._0.mainSmartcutId)
        };
}

function track$9(properties) {
  window.analytics.track("Started Recording", preparePropertiesForSegment$3(properties));
  
}

var TrackStartedRecording = {
  track: track$9
};

function finalSmartcutRecordingProps_encode(v) {
  return Js_dict.fromArray([
              [
                "numCommands",
                Decco.intToJson(v.numCommands)
              ],
              [
                "hosts",
                Decco.arrayToJson(Decco.stringToJson, v.hosts)
              ]
            ]);
}

function finalSmartcutRecordingProps_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var numCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numCommands"), null));
  if (numCommands.TAG === /* Ok */0) {
    var hosts = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "hosts"), null));
    if (hosts.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                numCommands: numCommands._0,
                hosts: hosts._0
              }
            };
    }
    var e = hosts._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".hosts" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = numCommands._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".numCommands" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function finalSmartcutProps_encode(v) {
  return Js_dict.fromArray([
              [
                "numCommands",
                Decco.intToJson(v.numCommands)
              ],
              [
                "numParams",
                Decco.intToJson(v.numParams)
              ],
              [
                "hosts",
                Decco.arrayToJson(Decco.stringToJson, v.hosts)
              ]
            ]);
}

function finalSmartcutProps_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var numCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numCommands"), null));
  if (numCommands.TAG === /* Ok */0) {
    var numParams = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numParams"), null));
    if (numParams.TAG === /* Ok */0) {
      var hosts = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "hosts"), null));
      if (hosts.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  numCommands: numCommands._0,
                  numParams: numParams._0,
                  hosts: hosts._0
                }
              };
      }
      var e = hosts._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".hosts" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = numParams._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".numParams" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = numCommands._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".numCommands" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function track$10(properties) {
  window.analytics.track("Stopped Recording", properties);
  
}

var TrackAttemptedStopRecording = {
  track: track$10
};

function track$11(properties) {
  window.analytics.track("Finished Authoring Smartcut", properties);
  
}

var TrackFinishedAuthoringSmartcut = {
  track: track$11
};

function preparePropertiesForSegment$4(param) {
  return {
          smartcutId: param.smartcutId,
          numCommands: param.numCommands,
          numParams: param.numParams,
          hosts: param.hosts,
          visibility: Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility),
          isOutdated: param.isOutdated,
          hasLoginSmartcut: param.hasLoginSmartcut
        };
}

function track$12(properties) {
  window.analytics.track("Interested In Installing Smartcut", preparePropertiesForSegment$4(properties));
  
}

var TrackInterestedInInstallingSmartcut = {
  track: track$12
};

function preparePropertiesForSegment$5(param) {
  return {
          smartcutId: param.smartcutId,
          numCommands: param.numCommands,
          numParams: param.numParams,
          hosts: param.hosts,
          visibility: Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility),
          isOutdated: param.isOutdated,
          hasLoginSmartcut: param.hasLoginSmartcut
        };
}

function track$13(properties) {
  window.analytics.track("Attempt to Install Smartcut", preparePropertiesForSegment$5(properties));
  
}

var TrackAttemptInstallSmartcut = {
  track: track$13
};

function trackUserAttemptToContactSupport(param) {
  window.analytics.track("User attempted to contact support");
  
}

function PageOnboardingSpecified(Step) {
  var WithStringified = {};
  var TrackedOnboardingPageStateProps = {
    WithStringified: WithStringified
  };
  var preparePropertiesForSegment = function (param) {
    return {
            step: Curry._1(Step.humanize, param.step)
          };
  };
  var track = function (properties) {
    window.analytics.track("Onboarding: User reloads page", preparePropertiesForSegment(properties));
    
  };
  var TrackPageOnLoad = {
    track: track
  };
  var preparePropertiesForSegment$1 = function (param) {
    return {
            step: Curry._1(Step.humanize, param.step)
          };
  };
  var track$1 = function (properties) {
    window.analytics.track("Onboarding: Step transition", preparePropertiesForSegment$1(properties));
    
  };
  var TrackStepTransition = {
    track: track$1
  };
  var TrackedOnboardingCollectedPoshmarkUsername = {};
  var preparePropertiesForSegment$2 = function (param) {
    return {
            username: param.username
          };
  };
  var track$2 = function (properties) {
    window.analytics.track("Onboarding: Collected Poshmark Username", preparePropertiesForSegment$2(properties));
    
  };
  var TrackOnboardingCollectedPoshmarkUsername = {
    track: track$2
  };
  var trackUserCheckingPoshmarkLogin = function (param) {
    window.analytics.track("Onboarding: user checks the Poshmark login");
    
  };
  var track$3 = function (properties) {
    window.analytics.track("Onboarding: User setting up smartcut schedule", convertTypes(properties));
    
  };
  var TrackSettingUpInstalledSmartcutSchedule = {
    track: track$3
  };
  var track$4 = function (properties) {
    window.analytics.track("Onboarding: User successfully set up smartcut schedule", convertTypes(properties));
    
  };
  var TrackSuccessfullySetUpInstalledSmartcutSchedule = {
    track: track$4
  };
  var track$5 = function (properties) {
    window.analytics.track("Onboarding: user attempt to try out the smartcut", properties);
    
  };
  var TrackUserAttemptForSmartcutTryOut = {
    track: track$5
  };
  return {
          TrackedOnboardingPageStateProps: TrackedOnboardingPageStateProps,
          TrackPageOnLoad: TrackPageOnLoad,
          TrackStepTransition: TrackStepTransition,
          TrackedOnboardingCollectedPoshmarkUsername: TrackedOnboardingCollectedPoshmarkUsername,
          TrackOnboardingCollectedPoshmarkUsername: TrackOnboardingCollectedPoshmarkUsername,
          trackUserCheckingPoshmarkLogin: trackUserCheckingPoshmarkLogin,
          TrackSettingUpInstalledSmartcutSchedule: TrackSettingUpInstalledSmartcutSchedule,
          TrackSuccessfullySetUpInstalledSmartcutSchedule: TrackSuccessfullySetUpInstalledSmartcutSchedule,
          TrackUserAttemptForSmartcutTryOut: TrackUserAttemptForSmartcutTryOut
        };
}

function preparePropertiesForSegment$6(param) {
  return {
          smartcutId: param.smartcutId,
          numCommands: param.numCommands,
          numParams: param.numParams,
          hosts: param.hosts,
          visibility: Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility),
          isOutdated: param.isOutdated,
          hasLoginSmartcut: param.hasLoginSmartcut
        };
}

function track$14(properties) {
  window.analytics.track("Begin AutoInstall Smartcut", preparePropertiesForSegment$6(properties));
  
}

var TrackBeginAutoInstallSmartcut = {
  track: track$14
};

function preparePropertiesForSegment$7(param) {
  return {
          smartcutId: param.smartcutId,
          numCommands: param.numCommands,
          numParams: param.numParams,
          hosts: param.hosts,
          visibility: Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility),
          isOutdated: param.isOutdated,
          hasLoginSmartcut: param.hasLoginSmartcut
        };
}

function track$15(properties) {
  window.analytics.track("Install Smartcut Success", preparePropertiesForSegment$7(properties));
  
}

var TrackInstallSmartcutSuccess = {
  track: track$15
};

function preparePropertiesForSegment$8(param) {
  return {
          smartcutId: param.smartcutId,
          numCommands: param.numCommands,
          numParams: param.numParams,
          hosts: param.hosts,
          visibility: Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility),
          isOutdated: param.isOutdated,
          hasLoginSmartcut: param.hasLoginSmartcut
        };
}

function track$16(properties) {
  window.analytics.track("Install Smartcut Failed", preparePropertiesForSegment$8(properties));
  
}

var TrackInstallSmartcutFailed = {
  track: track$16
};

function finalSmartcutPropsWithId_encode(v) {
  return Js_dict.fromArray([
              [
                "id",
                Decco.stringToJson(v.id)
              ],
              [
                "numCommands",
                Decco.intToJson(v.numCommands)
              ],
              [
                "numParams",
                Decco.intToJson(v.numParams)
              ],
              [
                "hosts",
                Decco.arrayToJson(Decco.stringToJson, v.hosts)
              ]
            ]);
}

function finalSmartcutPropsWithId_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var numCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numCommands"), null));
    if (numCommands.TAG === /* Ok */0) {
      var numParams = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numParams"), null));
      if (numParams.TAG === /* Ok */0) {
        var hosts = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "hosts"), null));
        if (hosts.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    id: id._0,
                    numCommands: numCommands._0,
                    numParams: numParams._0,
                    hosts: hosts._0
                  }
                };
        }
        var e = hosts._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".hosts" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = numParams._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".numParams" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = numCommands._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".numCommands" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function t_encode$3(v) {
  return Js_dict.fromArray([
              [
                "triggeredBy",
                Decco.stringToJson(v.triggeredBy)
              ],
              [
                "permissions",
                Decco.arrayToJson(Decco.stringToJson, v.permissions)
              ]
            ]);
}

function t_decode$3(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var triggeredBy = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "triggeredBy"), null));
  if (triggeredBy.TAG === /* Ok */0) {
    var permissions = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "permissions"), null));
    if (permissions.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                triggeredBy: triggeredBy._0,
                permissions: permissions._0
              }
            };
    }
    var e = permissions._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".permissions" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = triggeredBy._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".triggeredBy" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var WithStringFields$1 = {
  t_encode: t_encode$3,
  t_decode: t_decode$3
};

function t_encode$4(v) {
  return Js_dict.fromArray([
              [
                "triggeredBy",
                PermissionAndOrigin$SmartcutsMacros.PermissionTrigger.t_encode(v.triggeredBy)
              ],
              [
                "permissions",
                Decco.arrayToJson(PermissionAndOrigin$SmartcutsMacros.t_encode, v.permissions)
              ]
            ]);
}

function t_decode$4(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var triggeredBy = PermissionAndOrigin$SmartcutsMacros.PermissionTrigger.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "triggeredBy"), null));
  if (triggeredBy.TAG === /* Ok */0) {
    var permissions = Decco.arrayFromJson(PermissionAndOrigin$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "permissions"), null));
    if (permissions.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                triggeredBy: triggeredBy._0,
                permissions: permissions._0
              }
            };
    }
    var e = permissions._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".permissions" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = triggeredBy._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".triggeredBy" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var TrackedPermissionEventProps = {
  WithStringFields: WithStringFields$1,
  t_encode: t_encode$4,
  t_decode: t_decode$4
};

function preparePropertiesForSegment$9(param) {
  return {
          triggeredBy: PermissionAndOrigin$SmartcutsMacros.PermissionTrigger.justVariantStringMinusParams(param.triggeredBy),
          permissions: Belt_Array.map(param.permissions, PermissionAndOrigin$SmartcutsMacros.toString)
        };
}

function track$17(properties) {
  window.analytics.track("About to Explain Permissions", preparePropertiesForSegment$9(properties));
  
}

var TrackAboutToExplainPermission = {
  track: track$17
};

function preparePropertiesForSegment$10(param) {
  return {
          triggeredBy: PermissionAndOrigin$SmartcutsMacros.PermissionTrigger.justVariantStringMinusParams(param.triggeredBy),
          permissions: Belt_Array.map(param.permissions, PermissionAndOrigin$SmartcutsMacros.toString)
        };
}

function track$18(properties) {
  window.analytics.track("Grant Permissions", preparePropertiesForSegment$10(properties));
  
}

var TrackPermissionGrant = {
  track: track$18
};

function preparePropertiesForSegment$11(param) {
  return {
          triggeredBy: PermissionAndOrigin$SmartcutsMacros.PermissionTrigger.justVariantStringMinusParams(param.triggeredBy),
          permissions: Belt_Array.map(param.permissions, PermissionAndOrigin$SmartcutsMacros.toString)
        };
}

function track$19(properties) {
  window.analytics.track("Deny Permissions", preparePropertiesForSegment$11(properties));
  
}

var TrackPermissionDeny = {
  track: track$19
};

function t_encode$5(v) {
  return Js_dict.fromArray([
              [
                "smartcutId",
                SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
              ],
              [
                "numPlaybacks",
                Decco.intToJson(v.numPlaybacks)
              ],
              [
                "numCommands",
                Decco.intToJson(v.numCommands)
              ],
              [
                "numParams",
                Decco.intToJson(v.numParams)
              ],
              [
                "hosts",
                Decco.arrayToJson(Decco.stringToJson, v.hosts)
              ],
              [
                "visibility",
                Decco.stringToJson(v.visibility)
              ],
              [
                "trigger",
                Decco.stringToJson(v.trigger)
              ],
              [
                "hasLoginSmartcut",
                Decco.boolToJson(v.hasLoginSmartcut)
              ]
            ]);
}

function t_decode$5(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
  if (smartcutId.TAG === /* Ok */0) {
    var numPlaybacks = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numPlaybacks"), null));
    if (numPlaybacks.TAG === /* Ok */0) {
      var numCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numCommands"), null));
      if (numCommands.TAG === /* Ok */0) {
        var numParams = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numParams"), null));
        if (numParams.TAG === /* Ok */0) {
          var hosts = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "hosts"), null));
          if (hosts.TAG === /* Ok */0) {
            var visibility = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "visibility"), null));
            if (visibility.TAG === /* Ok */0) {
              var trigger = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trigger"), null));
              if (trigger.TAG === /* Ok */0) {
                var hasLoginSmartcut = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hasLoginSmartcut"), null));
                if (hasLoginSmartcut.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            smartcutId: smartcutId._0,
                            numPlaybacks: numPlaybacks._0,
                            numCommands: numCommands._0,
                            numParams: numParams._0,
                            hosts: hosts._0,
                            visibility: visibility._0,
                            trigger: trigger._0,
                            hasLoginSmartcut: hasLoginSmartcut._0
                          }
                        };
                }
                var e = hasLoginSmartcut._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".hasLoginSmartcut" + e.path,
                          message: e.message,
                          value: e.value
                        }
                      };
              }
              var e$1 = trigger._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".trigger" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = visibility._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".visibility" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = hosts._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".hosts" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
        }
        var e$4 = numParams._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".numParams" + e$4.path,
                  message: e$4.message,
                  value: e$4.value
                }
              };
      }
      var e$5 = numCommands._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".numCommands" + e$5.path,
                message: e$5.message,
                value: e$5.value
              }
            };
    }
    var e$6 = numPlaybacks._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".numPlaybacks" + e$6.path,
              message: e$6.message,
              value: e$6.value
            }
          };
  }
  var e$7 = smartcutId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".smartcutId" + e$7.path,
            message: e$7.message,
            value: e$7.value
          }
        };
}

var WithStringTrigger = {
  t_encode: t_encode$5,
  t_decode: t_decode$5
};

function t_encode$6(v) {
  return Js_dict.fromArray([
              [
                "smartcutId",
                SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
              ],
              [
                "numPlaybacks",
                Decco.intToJson(v.numPlaybacks)
              ],
              [
                "numCommands",
                Decco.intToJson(v.numCommands)
              ],
              [
                "numParams",
                Decco.intToJson(v.numParams)
              ],
              [
                "hosts",
                Decco.arrayToJson(Decco.stringToJson, v.hosts)
              ],
              [
                "visibility",
                Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.t_encode, v.visibility)
              ],
              [
                "trigger",
                PlaybackTrigger$SmartcutsMacros.t_encode(v.trigger)
              ],
              [
                "hasLoginSmartcut",
                Decco.boolToJson(v.hasLoginSmartcut)
              ]
            ]);
}

function t_decode$6(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
  if (smartcutId.TAG === /* Ok */0) {
    var numPlaybacks = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numPlaybacks"), null));
    if (numPlaybacks.TAG === /* Ok */0) {
      var numCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numCommands"), null));
      if (numCommands.TAG === /* Ok */0) {
        var numParams = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numParams"), null));
        if (numParams.TAG === /* Ok */0) {
          var hosts = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "hosts"), null));
          if (hosts.TAG === /* Ok */0) {
            var visibility = Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "visibility"), null));
            if (visibility.TAG === /* Ok */0) {
              var trigger = PlaybackTrigger$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trigger"), null));
              if (trigger.TAG === /* Ok */0) {
                var hasLoginSmartcut = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hasLoginSmartcut"), null));
                if (hasLoginSmartcut.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            smartcutId: smartcutId._0,
                            numPlaybacks: numPlaybacks._0,
                            numCommands: numCommands._0,
                            numParams: numParams._0,
                            hosts: hosts._0,
                            visibility: visibility._0,
                            trigger: trigger._0,
                            hasLoginSmartcut: hasLoginSmartcut._0
                          }
                        };
                }
                var e = hasLoginSmartcut._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".hasLoginSmartcut" + e.path,
                          message: e.message,
                          value: e.value
                        }
                      };
              }
              var e$1 = trigger._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".trigger" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = visibility._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".visibility" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = hosts._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".hosts" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
        }
        var e$4 = numParams._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".numParams" + e$4.path,
                  message: e$4.message,
                  value: e$4.value
                }
              };
      }
      var e$5 = numCommands._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".numCommands" + e$5.path,
                message: e$5.message,
                value: e$5.value
              }
            };
    }
    var e$6 = numPlaybacks._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".numPlaybacks" + e$6.path,
              message: e$6.message,
              value: e$6.value
            }
          };
  }
  var e$7 = smartcutId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".smartcutId" + e$7.path,
            message: e$7.message,
            value: e$7.value
          }
        };
}

function stringify$1(param) {
  return "{smartcutId: " + param.smartcutId + ", numPlaybacks: " + (String(param.numPlaybacks) + (", numCommands: " + (String(param.numCommands) + (", numParams: " + (String(param.numParams) + (", hosts: " + (StringUtils$SmartcutsMacros.join(", ", $$Array.to_list(param.hosts)) + (", visibility: " + (Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility) + (", trigger: " + (PlaybackTrigger$SmartcutsMacros.stringify(param.trigger) + (", hasLoginSmartcut: " + (Pervasives.string_of_bool(param.hasLoginSmartcut) + "}")))))))))))));
}

function fromStartPlayback(startPlayback) {
  var match = StartPlayback$SmartcutsMacros.view(startPlayback);
  var numParams = match.numParams;
  var visibility = match.visibility;
  var origins = match.origins;
  var trigger = match.trigger;
  var commandLog = match.commandLog;
  var match$1 = match.loadedSmartcut.smartcut;
  var loginSmartcuts = match$1.loginSmartcuts;
  var smartcutId = match$1.id;
  return StartPlayback$SmartcutsMacros.numExecutions(startPlayback).then(function (numPlaybacks) {
              return Promise.resolve({
                          smartcutId: smartcutId,
                          numPlaybacks: numPlaybacks,
                          numCommands: List.length(commandLog),
                          numParams: numParams,
                          hosts: origins,
                          visibility: visibility,
                          trigger: trigger,
                          hasLoginSmartcut: !Curry._1(LoginSmartcut$SmartcutsMacros.ByHostnameAndScenario.isEmpty, loginSmartcuts)
                        });
            });
}

var TrackedStartPlaybackSet = {
  WithStringTrigger: WithStringTrigger,
  t_encode: t_encode$6,
  t_decode: t_decode$6,
  stringify: stringify$1,
  fromStartPlayback: fromStartPlayback
};

function t_encode$7(v) {
  return Js_dict.fromArray([
              [
                "smartcutId",
                SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
              ],
              [
                "numPlaybacks",
                Decco.intToJson(v.numPlaybacks)
              ],
              [
                "numSucceeded",
                Decco.intToJson(v.numSucceeded)
              ],
              [
                "numFailed",
                Decco.intToJson(v.numFailed)
              ],
              [
                "numCommands",
                Decco.intToJson(v.numCommands)
              ],
              [
                "numParams",
                Decco.intToJson(v.numParams)
              ],
              [
                "hosts",
                Decco.arrayToJson(Decco.stringToJson, v.hosts)
              ],
              [
                "visibility",
                Decco.stringToJson(v.visibility)
              ],
              [
                "trigger",
                Decco.stringToJson(v.trigger)
              ],
              [
                "hasLoginSmartcut",
                Decco.boolToJson(v.hasLoginSmartcut)
              ]
            ]);
}

function t_decode$7(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
  if (smartcutId.TAG === /* Ok */0) {
    var numPlaybacks = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numPlaybacks"), null));
    if (numPlaybacks.TAG === /* Ok */0) {
      var numSucceeded = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numSucceeded"), null));
      if (numSucceeded.TAG === /* Ok */0) {
        var numFailed = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numFailed"), null));
        if (numFailed.TAG === /* Ok */0) {
          var numCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numCommands"), null));
          if (numCommands.TAG === /* Ok */0) {
            var numParams = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numParams"), null));
            if (numParams.TAG === /* Ok */0) {
              var hosts = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "hosts"), null));
              if (hosts.TAG === /* Ok */0) {
                var visibility = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "visibility"), null));
                if (visibility.TAG === /* Ok */0) {
                  var trigger = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trigger"), null));
                  if (trigger.TAG === /* Ok */0) {
                    var hasLoginSmartcut = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hasLoginSmartcut"), null));
                    if (hasLoginSmartcut.TAG === /* Ok */0) {
                      return {
                              TAG: /* Ok */0,
                              _0: {
                                smartcutId: smartcutId._0,
                                numPlaybacks: numPlaybacks._0,
                                numSucceeded: numSucceeded._0,
                                numFailed: numFailed._0,
                                numCommands: numCommands._0,
                                numParams: numParams._0,
                                hosts: hosts._0,
                                visibility: visibility._0,
                                trigger: trigger._0,
                                hasLoginSmartcut: hasLoginSmartcut._0
                              }
                            };
                    }
                    var e = hasLoginSmartcut._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".hasLoginSmartcut" + e.path,
                              message: e.message,
                              value: e.value
                            }
                          };
                  }
                  var e$1 = trigger._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".trigger" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                          }
                        };
                }
                var e$2 = visibility._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".visibility" + e$2.path,
                          message: e$2.message,
                          value: e$2.value
                        }
                      };
              }
              var e$3 = hosts._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".hosts" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                      }
                    };
            }
            var e$4 = numParams._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".numParams" + e$4.path,
                      message: e$4.message,
                      value: e$4.value
                    }
                  };
          }
          var e$5 = numCommands._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".numCommands" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
        }
        var e$6 = numFailed._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".numFailed" + e$6.path,
                  message: e$6.message,
                  value: e$6.value
                }
              };
      }
      var e$7 = numSucceeded._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".numSucceeded" + e$7.path,
                message: e$7.message,
                value: e$7.value
              }
            };
    }
    var e$8 = numPlaybacks._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".numPlaybacks" + e$8.path,
              message: e$8.message,
              value: e$8.value
            }
          };
  }
  var e$9 = smartcutId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".smartcutId" + e$9.path,
            message: e$9.message,
            value: e$9.value
          }
        };
}

var WithStringTrigger$1 = {
  t_encode: t_encode$7,
  t_decode: t_decode$7
};

function t_encode$8(v) {
  return Js_dict.fromArray([
              [
                "smartcutId",
                SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
              ],
              [
                "numPlaybacks",
                Decco.intToJson(v.numPlaybacks)
              ],
              [
                "numSucceeded",
                Decco.intToJson(v.numSucceeded)
              ],
              [
                "numFailed",
                Decco.intToJson(v.numFailed)
              ],
              [
                "numCommands",
                Decco.intToJson(v.numCommands)
              ],
              [
                "numParams",
                Decco.intToJson(v.numParams)
              ],
              [
                "hosts",
                Decco.arrayToJson(Decco.stringToJson, v.hosts)
              ],
              [
                "visibility",
                Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.t_encode, v.visibility)
              ],
              [
                "trigger",
                PlaybackTrigger$SmartcutsMacros.t_encode(v.trigger)
              ],
              [
                "hasLoginSmartcut",
                Decco.boolToJson(v.hasLoginSmartcut)
              ]
            ]);
}

function t_decode$8(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
  if (smartcutId.TAG === /* Ok */0) {
    var numPlaybacks = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numPlaybacks"), null));
    if (numPlaybacks.TAG === /* Ok */0) {
      var numSucceeded = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numSucceeded"), null));
      if (numSucceeded.TAG === /* Ok */0) {
        var numFailed = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numFailed"), null));
        if (numFailed.TAG === /* Ok */0) {
          var numCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numCommands"), null));
          if (numCommands.TAG === /* Ok */0) {
            var numParams = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numParams"), null));
            if (numParams.TAG === /* Ok */0) {
              var hosts = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "hosts"), null));
              if (hosts.TAG === /* Ok */0) {
                var visibility = Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "visibility"), null));
                if (visibility.TAG === /* Ok */0) {
                  var trigger = PlaybackTrigger$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trigger"), null));
                  if (trigger.TAG === /* Ok */0) {
                    var hasLoginSmartcut = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hasLoginSmartcut"), null));
                    if (hasLoginSmartcut.TAG === /* Ok */0) {
                      return {
                              TAG: /* Ok */0,
                              _0: {
                                smartcutId: smartcutId._0,
                                numPlaybacks: numPlaybacks._0,
                                numSucceeded: numSucceeded._0,
                                numFailed: numFailed._0,
                                numCommands: numCommands._0,
                                numParams: numParams._0,
                                hosts: hosts._0,
                                visibility: visibility._0,
                                trigger: trigger._0,
                                hasLoginSmartcut: hasLoginSmartcut._0
                              }
                            };
                    }
                    var e = hasLoginSmartcut._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".hasLoginSmartcut" + e.path,
                              message: e.message,
                              value: e.value
                            }
                          };
                  }
                  var e$1 = trigger._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".trigger" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                          }
                        };
                }
                var e$2 = visibility._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".visibility" + e$2.path,
                          message: e$2.message,
                          value: e$2.value
                        }
                      };
              }
              var e$3 = hosts._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".hosts" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                      }
                    };
            }
            var e$4 = numParams._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".numParams" + e$4.path,
                      message: e$4.message,
                      value: e$4.value
                    }
                  };
          }
          var e$5 = numCommands._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".numCommands" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
        }
        var e$6 = numFailed._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".numFailed" + e$6.path,
                  message: e$6.message,
                  value: e$6.value
                }
              };
      }
      var e$7 = numSucceeded._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".numSucceeded" + e$7.path,
                message: e$7.message,
                value: e$7.value
              }
            };
    }
    var e$8 = numPlaybacks._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".numPlaybacks" + e$8.path,
              message: e$8.message,
              value: e$8.value
            }
          };
  }
  var e$9 = smartcutId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".smartcutId" + e$9.path,
            message: e$9.message,
            value: e$9.value
          }
        };
}

function stringify$2(param) {
  return "{smartcutId: " + (param.smartcutId + (", numPlaybacks: " + (String(param.numPlaybacks) + (", numSucceeded: " + (String(param.numSucceeded) + (", numFailed: " + (String(param.numFailed) + (", numCommands: " + (String(param.numCommands) + (", numParams: " + (String(param.numParams) + (", hosts: " + (StringUtils$SmartcutsMacros.join(", ", $$Array.to_list(param.hosts)) + (", visibility: " + (Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility) + (", trigger: " + (PlaybackTrigger$SmartcutsMacros.stringify(param.trigger) + (", hasLoginSmartcut: " + (Pervasives.string_of_bool(param.hasLoginSmartcut) + "}")))))))))))))))))));
}

var TrackedFinishPlaybackSet = {
  WithStringTrigger: WithStringTrigger$1,
  t_encode: t_encode$8,
  t_decode: t_decode$8,
  stringify: stringify$2
};

function t_encode$9(v) {
  switch (v) {
    case /* NewWindowCommand */0 :
        return ["NewWindowCommand"];
    case /* NewWindowWithUrlCommand */1 :
        return ["NewWindowWithUrlCommand"];
    case /* NewTabCommand */2 :
        return ["NewTabCommand"];
    case /* NewTabWithUrlCommand */3 :
        return ["NewTabWithUrlCommand"];
    case /* CloseTabCommand */4 :
        return ["CloseTabCommand"];
    case /* FocusTabCommand */5 :
        return ["FocusTabCommand"];
    case /* URLCommand */6 :
        return ["URLCommand"];
    case /* OpenedLinkCommand */7 :
        return ["OpenedLinkCommand"];
    case /* SubmitFormCommand */8 :
        return ["SubmitFormCommand"];
    case /* SubmitFormRedirectCommand */9 :
        return ["SubmitFormRedirectCommand"];
    case /* ClientRedirectCommand */10 :
        return ["ClientRedirectCommand"];
    case /* ServerRedirectCommand */11 :
        return ["ServerRedirectCommand"];
    case /* ReloadCommand */12 :
        return ["ReloadCommand"];
    case /* ForwardCommand */13 :
        return ["ForwardCommand"];
    case /* BackCommand */14 :
        return ["BackCommand"];
    case /* ClickCommand */15 :
        return ["ClickCommand"];
    case /* ClickInputCommand */16 :
        return ["ClickInputCommand"];
    case /* ClickContentEditableCommand */17 :
        return ["ClickContentEditableCommand"];
    case /* TypeCommand */18 :
        return ["TypeCommand"];
    case /* CheckboxCommand */19 :
        return ["CheckboxCommand"];
    case /* SelectCommand */20 :
        return ["SelectCommand"];
    case /* RadioCommand */21 :
        return ["RadioCommand"];
    case /* KeyCommand */22 :
        return ["KeyCommand"];
    case /* KeyComboCommand */23 :
        return ["KeyComboCommand"];
    case /* SelectionCommand */24 :
        return ["SelectionCommand"];
    case /* MoveInputCursorCommand */25 :
        return ["MoveInputCursorCommand"];
    case /* MoveContentEditableCursorCommand */26 :
        return ["MoveContentEditableCursorCommand"];
    case /* CopyCommand */27 :
        return ["CopyCommand"];
    case /* CopyLinkAddressCommand */28 :
        return ["CopyLinkAddressCommand"];
    case /* CopyImageSrcCommand */29 :
        return ["CopyImageSrcCommand"];
    case /* CutCommand */30 :
        return ["CutCommand"];
    case /* PasteInInputCommand */31 :
        return ["PasteInInputCommand"];
    case /* PasteInContentEditableCommand */32 :
        return ["PasteInContentEditableCommand"];
    case /* DragCommand */33 :
        return ["DragCommand"];
    case /* DropCommand */34 :
        return ["DropCommand"];
    case /* ScrollCommand */35 :
        return ["ScrollCommand"];
    case /* DownloadCommand */36 :
        return ["DownloadCommand"];
    case /* GoogleSheetsCommand */37 :
        return ["GoogleSheetsCommand"];
    case /* ContextMenuCommand */38 :
        return ["ContextMenuCommand"];
    case /* LoopCommand */39 :
        return ["LoopCommand"];
    case /* SwitchCommand */40 :
        return ["SwitchCommand"];
    case /* ScreenshotToClipboardCommand */41 :
        return ["ScreenshotToClipboardCommand"];
    case /* PasteImageInContentEditableCommand */42 :
        return ["PasteImageInContentEditableCommand"];
    case /* PasswordCommand */43 :
        return ["PasswordCommand"];
    case /* ClickToOAuthCommand */44 :
        return ["ClickToOAuthCommand"];
    case /* UploadCommand */45 :
        return ["UploadCommand"];
    case /* WithElementGroupsCommand */46 :
        return ["WithElementGroupsCommand"];
    
  }
}

function t_decode$9(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "BackCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* BackCommand */14
                  };
          }
      case "CheckboxCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* CheckboxCommand */19
                  };
          }
      case "ClickCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ClickCommand */15
                  };
          }
      case "ClickContentEditableCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ClickContentEditableCommand */17
                  };
          }
      case "ClickInputCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ClickInputCommand */16
                  };
          }
      case "ClickToOAuthCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ClickToOAuthCommand */44
                  };
          }
      case "ClientRedirectCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ClientRedirectCommand */10
                  };
          }
      case "CloseTabCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* CloseTabCommand */4
                  };
          }
      case "ContextMenuCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ContextMenuCommand */38
                  };
          }
      case "CopyCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* CopyCommand */27
                  };
          }
      case "CopyImageSrcCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* CopyImageSrcCommand */29
                  };
          }
      case "CopyLinkAddressCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* CopyLinkAddressCommand */28
                  };
          }
      case "CutCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* CutCommand */30
                  };
          }
      case "DownloadCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DownloadCommand */36
                  };
          }
      case "DragCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DragCommand */33
                  };
          }
      case "DropCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DropCommand */34
                  };
          }
      case "FocusTabCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* FocusTabCommand */5
                  };
          }
      case "ForwardCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ForwardCommand */13
                  };
          }
      case "GoogleSheetsCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* GoogleSheetsCommand */37
                  };
          }
      case "KeyComboCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* KeyComboCommand */23
                  };
          }
      case "KeyCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* KeyCommand */22
                  };
          }
      case "LoopCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* LoopCommand */39
                  };
          }
      case "MoveContentEditableCursorCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* MoveContentEditableCursorCommand */26
                  };
          }
      case "MoveInputCursorCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* MoveInputCursorCommand */25
                  };
          }
      case "NewTabCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NewTabCommand */2
                  };
          }
      case "NewTabWithUrlCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NewTabWithUrlCommand */3
                  };
          }
      case "NewWindowCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NewWindowCommand */0
                  };
          }
      case "NewWindowWithUrlCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NewWindowWithUrlCommand */1
                  };
          }
      case "OpenedLinkCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* OpenedLinkCommand */7
                  };
          }
      case "PasswordCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* PasswordCommand */43
                  };
          }
      case "PasteImageInContentEditableCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* PasteImageInContentEditableCommand */42
                  };
          }
      case "PasteInContentEditableCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* PasteInContentEditableCommand */32
                  };
          }
      case "PasteInInputCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* PasteInInputCommand */31
                  };
          }
      case "RadioCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* RadioCommand */21
                  };
          }
      case "ReloadCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ReloadCommand */12
                  };
          }
      case "ScreenshotToClipboardCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ScreenshotToClipboardCommand */41
                  };
          }
      case "ScrollCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ScrollCommand */35
                  };
          }
      case "SelectCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* SelectCommand */20
                  };
          }
      case "SelectionCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* SelectionCommand */24
                  };
          }
      case "ServerRedirectCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ServerRedirectCommand */11
                  };
          }
      case "SubmitFormCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* SubmitFormCommand */8
                  };
          }
      case "SubmitFormRedirectCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* SubmitFormRedirectCommand */9
                  };
          }
      case "SwitchCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* SwitchCommand */40
                  };
          }
      case "TypeCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* TypeCommand */18
                  };
          }
      case "URLCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* URLCommand */6
                  };
          }
      case "UploadCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* UploadCommand */45
                  };
          }
      case "WithElementGroupsCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* WithElementGroupsCommand */46
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify$3(v) {
  switch (v) {
    case /* NewWindowCommand */0 :
        return "NewWindowCommand";
    case /* NewWindowWithUrlCommand */1 :
        return "NewWindowWithUrlCommand";
    case /* NewTabCommand */2 :
        return "NewTabCommand";
    case /* NewTabWithUrlCommand */3 :
        return "NewTabWithUrlCommand";
    case /* CloseTabCommand */4 :
        return "CloseTabCommand";
    case /* FocusTabCommand */5 :
        return "FocusTabCommand";
    case /* URLCommand */6 :
        return "URLCommand";
    case /* OpenedLinkCommand */7 :
        return "OpenedLinkCommand";
    case /* SubmitFormCommand */8 :
        return "SubmitFormCommand";
    case /* SubmitFormRedirectCommand */9 :
        return "SubmitFormRedirectCommand";
    case /* ClientRedirectCommand */10 :
        return "ClientRedirectCommand";
    case /* ServerRedirectCommand */11 :
        return "ServerRedirectCommand";
    case /* ReloadCommand */12 :
        return "ReloadCommand";
    case /* ForwardCommand */13 :
        return "ForwardCommand";
    case /* BackCommand */14 :
        return "BackCommand";
    case /* ClickCommand */15 :
        return "ClickCommand";
    case /* ClickInputCommand */16 :
        return "ClickInputCommand";
    case /* ClickContentEditableCommand */17 :
        return "ClickContentEditableCommand";
    case /* TypeCommand */18 :
        return "TypeCommand";
    case /* CheckboxCommand */19 :
        return "CheckboxCommand";
    case /* SelectCommand */20 :
        return "SelectCommand";
    case /* RadioCommand */21 :
        return "RadioCommand";
    case /* KeyCommand */22 :
        return "KeyCommand";
    case /* KeyComboCommand */23 :
        return "KeyComboCommand";
    case /* SelectionCommand */24 :
        return "SelectionCommand";
    case /* MoveInputCursorCommand */25 :
        return "MoveInputCursorCommand";
    case /* MoveContentEditableCursorCommand */26 :
        return "MoveContentEditableCursorCommand";
    case /* CopyCommand */27 :
        return "CopyCommand";
    case /* CopyLinkAddressCommand */28 :
        return "CopyLinkAddressCommand";
    case /* CopyImageSrcCommand */29 :
        return "CopyImageSrcCommand";
    case /* CutCommand */30 :
        return "CutCommand";
    case /* PasteInInputCommand */31 :
        return "PasteInInputCommand";
    case /* PasteInContentEditableCommand */32 :
        return "PasteInContentEditableCommand";
    case /* DragCommand */33 :
        return "DragCommand";
    case /* DropCommand */34 :
        return "DropCommand";
    case /* ScrollCommand */35 :
        return "ScrollCommand";
    case /* DownloadCommand */36 :
        return "DownloadCommand";
    case /* GoogleSheetsCommand */37 :
        return "GoogleSheetsCommand";
    case /* ContextMenuCommand */38 :
        return "ContextMenuCommand";
    case /* LoopCommand */39 :
        return "LoopCommand";
    case /* SwitchCommand */40 :
        return "SwitchCommand";
    case /* ScreenshotToClipboardCommand */41 :
        return "ScreenshotToClipboardCommand";
    case /* PasteImageInContentEditableCommand */42 :
        return "PasteImageInContentEditableCommand";
    case /* PasswordCommand */43 :
        return "PasswordCommand";
    case /* ClickToOAuthCommand */44 :
        return "ClickToOAuthCommand";
    case /* UploadCommand */45 :
        return "UploadCommand";
    case /* WithElementGroupsCommand */46 :
        return "WithElementGroupsCommand";
    
  }
}

function fromCommand(command) {
  if (typeof command === "number") {
    switch (command) {
      case /* ReloadCommand */0 :
          return /* ReloadCommand */12;
      case /* ForwardCommand */1 :
          return /* ForwardCommand */13;
      case /* BackCommand */2 :
          return /* BackCommand */14;
      
    }
  } else {
    switch (command.TAG | 0) {
      case /* NewWindowCommand */0 :
          return /* NewWindowCommand */0;
      case /* NewWindowWithUrlCommand */1 :
          return /* NewWindowWithUrlCommand */1;
      case /* NewTabCommand */2 :
          return /* NewTabCommand */2;
      case /* NewTabWithUrlCommand */3 :
          return /* NewTabWithUrlCommand */3;
      case /* CloseTabCommand */4 :
          return /* CloseTabCommand */4;
      case /* FocusTabCommand */5 :
          return /* FocusTabCommand */5;
      case /* URLCommand */6 :
          return /* URLCommand */6;
      case /* OpenedLinkCommand */7 :
          return /* OpenedLinkCommand */7;
      case /* SubmitFormCommand */8 :
          return /* SubmitFormCommand */8;
      case /* SubmitFormRedirectCommand */9 :
          return /* SubmitFormRedirectCommand */9;
      case /* ClientRedirectCommand */10 :
          return /* ClientRedirectCommand */10;
      case /* ServerRedirectCommand */11 :
          return /* ServerRedirectCommand */11;
      case /* ClickCommand */12 :
          return /* ClickCommand */15;
      case /* ClickInputCommand */13 :
          return /* ClickInputCommand */16;
      case /* ClickContentEditableCommand */14 :
          return /* ClickContentEditableCommand */17;
      case /* TypeCommand */15 :
          return /* TypeCommand */18;
      case /* CheckboxCommand */16 :
          return /* CheckboxCommand */19;
      case /* SelectCommand */17 :
          return /* SelectCommand */20;
      case /* RadioCommand */18 :
          return /* RadioCommand */21;
      case /* KeyCommand */19 :
          return /* KeyCommand */22;
      case /* KeyComboCommand */20 :
          return /* KeyComboCommand */23;
      case /* SelectionCommand */21 :
          return /* SelectionCommand */24;
      case /* MoveInputCursorCommand */22 :
          return /* MoveInputCursorCommand */25;
      case /* MoveContentEditableCursorCommand */23 :
          return /* MoveContentEditableCursorCommand */26;
      case /* CopyCommand */24 :
          return /* CopyCommand */27;
      case /* CopyLinkAddressCommand */25 :
          return /* CopyLinkAddressCommand */28;
      case /* CutCommand */26 :
          return /* CutCommand */30;
      case /* PasteInInputCommand */27 :
          return /* PasteInInputCommand */31;
      case /* PasteInContentEditableCommand */28 :
          return /* PasteInContentEditableCommand */32;
      case /* DragCommand */29 :
          return /* DragCommand */33;
      case /* DropCommand */30 :
          return /* DropCommand */34;
      case /* ScrollCommand */31 :
          return /* ScrollCommand */35;
      case /* DownloadCommand */32 :
          return /* DownloadCommand */36;
      case /* GoogleSheetsCommand */33 :
          return /* GoogleSheetsCommand */37;
      case /* ContextMenuCommand */34 :
          return /* ContextMenuCommand */38;
      case /* LoopCommand */35 :
          return /* LoopCommand */39;
      case /* SwitchCommand */36 :
          return /* SwitchCommand */40;
      case /* ScreenshotToClipboardCommand */37 :
          return /* ScreenshotToClipboardCommand */41;
      case /* PasteImageInContentEditableCommand */38 :
          return /* PasteImageInContentEditableCommand */42;
      case /* PasswordCommand */39 :
          return /* PasswordCommand */43;
      case /* ClickToOAuthCommand */40 :
          return /* ClickToOAuthCommand */44;
      case /* UploadCommand */41 :
          return /* UploadCommand */45;
      case /* CopyImageSrcCommand */42 :
          return /* CopyImageSrcCommand */29;
      case /* WithElementGroupsCommand */43 :
          return /* WithElementGroupsCommand */46;
      
    }
  }
}

var TrackedCommand = {
  t_encode: t_encode$9,
  t_decode: t_decode$9,
  stringify: stringify$3,
  fromCommand: fromCommand
};

function t_encode$10(v) {
  if (v) {
    return ["ContentScriptMainFrame"];
  } else {
    return ["BgScript"];
  }
}

function t_decode$10(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "BgScript" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* BgScript */0
                  };
          }
      case "ContentScriptMainFrame" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ContentScriptMainFrame */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify$4(v) {
  if (v) {
    return "ContentScriptMainFrame";
  } else {
    return "BgScript";
  }
}

var FailureEnv = {
  t_encode: t_encode$10,
  t_decode: t_decode$10,
  stringify: stringify$4
};

function t_encode$11(v) {
  return Js_dict.fromArray([
              [
                "smartcutId",
                SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
              ],
              [
                "trigger",
                Decco.stringToJson(v.trigger)
              ],
              [
                "numCommands",
                Decco.intToJson(v.numCommands)
              ],
              [
                "failedAfterNCommands",
                Decco.intToJson(v.failedAfterNCommands)
              ],
              [
                "failedIn",
                Decco.stringToJson(v.failedIn)
              ],
              [
                "failedOnHost",
                Decco.stringToJson(v.failedOnHost)
              ],
              [
                "failedOnUrl",
                Decco.stringToJson(v.failedOnUrl)
              ],
              [
                "failedWithCommand",
                Decco.stringToJson(v.failedWithCommand)
              ],
              [
                "failureReason",
                Decco.stringToJson(v.failureReason)
              ],
              [
                "visibility",
                Decco.stringToJson(v.visibility)
              ],
              [
                "hasLoginSmartcut",
                Decco.boolToJson(v.hasLoginSmartcut)
              ]
            ]);
}

function t_decode$11(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
  if (smartcutId.TAG === /* Ok */0) {
    var trigger = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trigger"), null));
    if (trigger.TAG === /* Ok */0) {
      var numCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numCommands"), null));
      if (numCommands.TAG === /* Ok */0) {
        var failedAfterNCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failedAfterNCommands"), null));
        if (failedAfterNCommands.TAG === /* Ok */0) {
          var failedIn = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failedIn"), null));
          if (failedIn.TAG === /* Ok */0) {
            var failedOnHost = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failedOnHost"), null));
            if (failedOnHost.TAG === /* Ok */0) {
              var failedOnUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failedOnUrl"), null));
              if (failedOnUrl.TAG === /* Ok */0) {
                var failedWithCommand = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failedWithCommand"), null));
                if (failedWithCommand.TAG === /* Ok */0) {
                  var failureReason = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failureReason"), null));
                  if (failureReason.TAG === /* Ok */0) {
                    var visibility = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "visibility"), null));
                    if (visibility.TAG === /* Ok */0) {
                      var hasLoginSmartcut = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hasLoginSmartcut"), null));
                      if (hasLoginSmartcut.TAG === /* Ok */0) {
                        return {
                                TAG: /* Ok */0,
                                _0: {
                                  smartcutId: smartcutId._0,
                                  trigger: trigger._0,
                                  numCommands: numCommands._0,
                                  failedAfterNCommands: failedAfterNCommands._0,
                                  failedIn: failedIn._0,
                                  failedOnHost: failedOnHost._0,
                                  failedOnUrl: failedOnUrl._0,
                                  failedWithCommand: failedWithCommand._0,
                                  failureReason: failureReason._0,
                                  visibility: visibility._0,
                                  hasLoginSmartcut: hasLoginSmartcut._0
                                }
                              };
                      }
                      var e = hasLoginSmartcut._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".hasLoginSmartcut" + e.path,
                                message: e.message,
                                value: e.value
                              }
                            };
                    }
                    var e$1 = visibility._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".visibility" + e$1.path,
                              message: e$1.message,
                              value: e$1.value
                            }
                          };
                  }
                  var e$2 = failureReason._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".failureReason" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                          }
                        };
                }
                var e$3 = failedWithCommand._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".failedWithCommand" + e$3.path,
                          message: e$3.message,
                          value: e$3.value
                        }
                      };
              }
              var e$4 = failedOnUrl._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".failedOnUrl" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                      }
                    };
            }
            var e$5 = failedOnHost._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".failedOnHost" + e$5.path,
                      message: e$5.message,
                      value: e$5.value
                    }
                  };
          }
          var e$6 = failedIn._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".failedIn" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
        }
        var e$7 = failedAfterNCommands._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".failedAfterNCommands" + e$7.path,
                  message: e$7.message,
                  value: e$7.value
                }
              };
      }
      var e$8 = numCommands._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".numCommands" + e$8.path,
                message: e$8.message,
                value: e$8.value
              }
            };
    }
    var e$9 = trigger._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".trigger" + e$9.path,
              message: e$9.message,
              value: e$9.value
            }
          };
  }
  var e$10 = smartcutId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".smartcutId" + e$10.path,
            message: e$10.message,
            value: e$10.value
          }
        };
}

var WithStringFields$2 = {
  t_encode: t_encode$11,
  t_decode: t_decode$11
};

function t_encode$12(v) {
  return Js_dict.fromArray([
              [
                "smartcutId",
                SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
              ],
              [
                "trigger",
                PlaybackTrigger$SmartcutsMacros.t_encode(v.trigger)
              ],
              [
                "numCommands",
                Decco.intToJson(v.numCommands)
              ],
              [
                "failedAfterNCommands",
                Decco.intToJson(v.failedAfterNCommands)
              ],
              [
                "failedIn",
                t_encode$10(v.failedIn)
              ],
              [
                "failedOnHost",
                Decco.stringToJson(v.failedOnHost)
              ],
              [
                "failedOnUrl",
                Decco.stringToJson(v.failedOnUrl)
              ],
              [
                "failedWithCommand",
                t_encode$9(v.failedWithCommand)
              ],
              [
                "failureReason",
                Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_encode, Bg__StateMachine__Shared$SmartcutsMacros.otherFailureReasonShared_encode, v.failureReason)
              ],
              [
                "visibility",
                Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.t_encode, v.visibility)
              ],
              [
                "hasLoginSmartcut",
                Decco.boolToJson(v.hasLoginSmartcut)
              ]
            ]);
}

function t_decode$12(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
  if (smartcutId.TAG === /* Ok */0) {
    var trigger = PlaybackTrigger$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trigger"), null));
    if (trigger.TAG === /* Ok */0) {
      var numCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numCommands"), null));
      if (numCommands.TAG === /* Ok */0) {
        var failedAfterNCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failedAfterNCommands"), null));
        if (failedAfterNCommands.TAG === /* Ok */0) {
          var failedIn = t_decode$10(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failedIn"), null));
          if (failedIn.TAG === /* Ok */0) {
            var failedOnHost = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failedOnHost"), null));
            if (failedOnHost.TAG === /* Ok */0) {
              var failedOnUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failedOnUrl"), null));
              if (failedOnUrl.TAG === /* Ok */0) {
                var failedWithCommand = t_decode$9(Belt_Option.getWithDefault(Js_dict.get(dict$1, "failedWithCommand"), null));
                if (failedWithCommand.TAG === /* Ok */0) {
                  var failureReason = Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_decode, Bg__StateMachine__Shared$SmartcutsMacros.otherFailureReasonShared_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "failureReason"), null));
                  if (failureReason.TAG === /* Ok */0) {
                    var visibility = Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "visibility"), null));
                    if (visibility.TAG === /* Ok */0) {
                      var hasLoginSmartcut = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hasLoginSmartcut"), null));
                      if (hasLoginSmartcut.TAG === /* Ok */0) {
                        return {
                                TAG: /* Ok */0,
                                _0: {
                                  smartcutId: smartcutId._0,
                                  trigger: trigger._0,
                                  numCommands: numCommands._0,
                                  failedAfterNCommands: failedAfterNCommands._0,
                                  failedIn: failedIn._0,
                                  failedOnHost: failedOnHost._0,
                                  failedOnUrl: failedOnUrl._0,
                                  failedWithCommand: failedWithCommand._0,
                                  failureReason: failureReason._0,
                                  visibility: visibility._0,
                                  hasLoginSmartcut: hasLoginSmartcut._0
                                }
                              };
                      }
                      var e = hasLoginSmartcut._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".hasLoginSmartcut" + e.path,
                                message: e.message,
                                value: e.value
                              }
                            };
                    }
                    var e$1 = visibility._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".visibility" + e$1.path,
                              message: e$1.message,
                              value: e$1.value
                            }
                          };
                  }
                  var e$2 = failureReason._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".failureReason" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                          }
                        };
                }
                var e$3 = failedWithCommand._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".failedWithCommand" + e$3.path,
                          message: e$3.message,
                          value: e$3.value
                        }
                      };
              }
              var e$4 = failedOnUrl._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".failedOnUrl" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                      }
                    };
            }
            var e$5 = failedOnHost._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".failedOnHost" + e$5.path,
                      message: e$5.message,
                      value: e$5.value
                    }
                  };
          }
          var e$6 = failedIn._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".failedIn" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
        }
        var e$7 = failedAfterNCommands._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".failedAfterNCommands" + e$7.path,
                  message: e$7.message,
                  value: e$7.value
                }
              };
      }
      var e$8 = numCommands._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".numCommands" + e$8.path,
                message: e$8.message,
                value: e$8.value
              }
            };
    }
    var e$9 = trigger._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".trigger" + e$9.path,
              message: e$9.message,
              value: e$9.value
            }
          };
  }
  var e$10 = smartcutId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".smartcutId" + e$10.path,
            message: e$10.message,
            value: e$10.value
          }
        };
}

function stringify$5(param) {
  return "{smartcutId: " + (param.smartcutId + (", trigger: " + (PlaybackTrigger$SmartcutsMacros.stringify(param.trigger) + (", numCommands: " + (String(param.numCommands) + (", failedAfterNCommands: " + (String(param.failedAfterNCommands) + (", failedIn: " + ((
                            param.failedIn ? "ContentScriptMainFrame" : "BgScript"
                          ) + (", failedOnUrl: " + (param.failedOnUrl + (", failedOnHost: " + (param.failedOnHost + (", failedWithCommand: " + (stringify$3(param.failedWithCommand) + (Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.stringify, Bg__StateMachine__Shared$SmartcutsMacros.stringifyOtherFailureReason, param.failureReason) + (", visibility: " + (Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility) + (", hasLoginSmartcut: " + (Pervasives.string_of_bool(param.hasLoginSmartcut) + "}"))))))))))))))))))));
}

var TrackedPlaybackFailure = {
  FailureEnv: FailureEnv,
  WithStringFields: WithStringFields$2,
  t_encode: t_encode$12,
  t_decode: t_decode$12,
  stringify: stringify$5
};

function t_encode$13(v) {
  return Js_dict.fromArray([
              [
                "smartcutId",
                SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
              ],
              [
                "trigger",
                Decco.stringToJson(v.trigger)
              ],
              [
                "numCommands",
                Decco.intToJson(v.numCommands)
              ],
              [
                "afterNCommands",
                Decco.intToJson(v.afterNCommands)
              ],
              [
                "numSucceeded",
                Decco.intToJson(v.numSucceeded)
              ],
              [
                "numFailed",
                Decco.intToJson(v.numFailed)
              ],
              [
                "host",
                Decco.stringToJson(v.host)
              ],
              [
                "url",
                Decco.stringToJson(v.url)
              ],
              [
                "command",
                Decco.stringToJson(v.command)
              ],
              [
                "visibility",
                Decco.stringToJson(v.visibility)
              ],
              [
                "hasLoginSmartcut",
                Decco.boolToJson(v.hasLoginSmartcut)
              ]
            ]);
}

function t_decode$13(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
  if (smartcutId.TAG === /* Ok */0) {
    var trigger = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trigger"), null));
    if (trigger.TAG === /* Ok */0) {
      var numCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numCommands"), null));
      if (numCommands.TAG === /* Ok */0) {
        var afterNCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "afterNCommands"), null));
        if (afterNCommands.TAG === /* Ok */0) {
          var numSucceeded = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numSucceeded"), null));
          if (numSucceeded.TAG === /* Ok */0) {
            var numFailed = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numFailed"), null));
            if (numFailed.TAG === /* Ok */0) {
              var host = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "host"), null));
              if (host.TAG === /* Ok */0) {
                var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
                if (url.TAG === /* Ok */0) {
                  var command = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "command"), null));
                  if (command.TAG === /* Ok */0) {
                    var visibility = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "visibility"), null));
                    if (visibility.TAG === /* Ok */0) {
                      var hasLoginSmartcut = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hasLoginSmartcut"), null));
                      if (hasLoginSmartcut.TAG === /* Ok */0) {
                        return {
                                TAG: /* Ok */0,
                                _0: {
                                  smartcutId: smartcutId._0,
                                  trigger: trigger._0,
                                  numCommands: numCommands._0,
                                  afterNCommands: afterNCommands._0,
                                  numSucceeded: numSucceeded._0,
                                  numFailed: numFailed._0,
                                  host: host._0,
                                  url: url._0,
                                  command: command._0,
                                  visibility: visibility._0,
                                  hasLoginSmartcut: hasLoginSmartcut._0
                                }
                              };
                      }
                      var e = hasLoginSmartcut._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".hasLoginSmartcut" + e.path,
                                message: e.message,
                                value: e.value
                              }
                            };
                    }
                    var e$1 = visibility._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".visibility" + e$1.path,
                              message: e$1.message,
                              value: e$1.value
                            }
                          };
                  }
                  var e$2 = command._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".command" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                          }
                        };
                }
                var e$3 = url._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".url" + e$3.path,
                          message: e$3.message,
                          value: e$3.value
                        }
                      };
              }
              var e$4 = host._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".host" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                      }
                    };
            }
            var e$5 = numFailed._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".numFailed" + e$5.path,
                      message: e$5.message,
                      value: e$5.value
                    }
                  };
          }
          var e$6 = numSucceeded._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".numSucceeded" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
        }
        var e$7 = afterNCommands._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".afterNCommands" + e$7.path,
                  message: e$7.message,
                  value: e$7.value
                }
              };
      }
      var e$8 = numCommands._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".numCommands" + e$8.path,
                message: e$8.message,
                value: e$8.value
              }
            };
    }
    var e$9 = trigger._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".trigger" + e$9.path,
              message: e$9.message,
              value: e$9.value
            }
          };
  }
  var e$10 = smartcutId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".smartcutId" + e$10.path,
            message: e$10.message,
            value: e$10.value
          }
        };
}

var WithStringFields$3 = {
  t_encode: t_encode$13,
  t_decode: t_decode$13
};

function t_encode$14(v) {
  return Js_dict.fromArray([
              [
                "smartcutId",
                SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
              ],
              [
                "trigger",
                PlaybackTrigger$SmartcutsMacros.t_encode(v.trigger)
              ],
              [
                "numCommands",
                Decco.intToJson(v.numCommands)
              ],
              [
                "afterNCommands",
                Decco.intToJson(v.afterNCommands)
              ],
              [
                "numSucceeded",
                Decco.intToJson(v.numSucceeded)
              ],
              [
                "numFailed",
                Decco.intToJson(v.numFailed)
              ],
              [
                "host",
                Decco.stringToJson(v.host)
              ],
              [
                "url",
                Decco.stringToJson(v.url)
              ],
              [
                "command",
                t_encode$9(v.command)
              ],
              [
                "visibility",
                Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.t_encode, v.visibility)
              ],
              [
                "hasLoginSmartcut",
                Decco.boolToJson(v.hasLoginSmartcut)
              ]
            ]);
}

function t_decode$14(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
  if (smartcutId.TAG === /* Ok */0) {
    var trigger = PlaybackTrigger$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trigger"), null));
    if (trigger.TAG === /* Ok */0) {
      var numCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numCommands"), null));
      if (numCommands.TAG === /* Ok */0) {
        var afterNCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "afterNCommands"), null));
        if (afterNCommands.TAG === /* Ok */0) {
          var numSucceeded = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numSucceeded"), null));
          if (numSucceeded.TAG === /* Ok */0) {
            var numFailed = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numFailed"), null));
            if (numFailed.TAG === /* Ok */0) {
              var host = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "host"), null));
              if (host.TAG === /* Ok */0) {
                var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
                if (url.TAG === /* Ok */0) {
                  var command = t_decode$9(Belt_Option.getWithDefault(Js_dict.get(dict$1, "command"), null));
                  if (command.TAG === /* Ok */0) {
                    var visibility = Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "visibility"), null));
                    if (visibility.TAG === /* Ok */0) {
                      var hasLoginSmartcut = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hasLoginSmartcut"), null));
                      if (hasLoginSmartcut.TAG === /* Ok */0) {
                        return {
                                TAG: /* Ok */0,
                                _0: {
                                  smartcutId: smartcutId._0,
                                  trigger: trigger._0,
                                  numCommands: numCommands._0,
                                  afterNCommands: afterNCommands._0,
                                  numSucceeded: numSucceeded._0,
                                  numFailed: numFailed._0,
                                  host: host._0,
                                  url: url._0,
                                  command: command._0,
                                  visibility: visibility._0,
                                  hasLoginSmartcut: hasLoginSmartcut._0
                                }
                              };
                      }
                      var e = hasLoginSmartcut._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".hasLoginSmartcut" + e.path,
                                message: e.message,
                                value: e.value
                              }
                            };
                    }
                    var e$1 = visibility._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".visibility" + e$1.path,
                              message: e$1.message,
                              value: e$1.value
                            }
                          };
                  }
                  var e$2 = command._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".command" + e$2.path,
                            message: e$2.message,
                            value: e$2.value
                          }
                        };
                }
                var e$3 = url._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".url" + e$3.path,
                          message: e$3.message,
                          value: e$3.value
                        }
                      };
              }
              var e$4 = host._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".host" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                      }
                    };
            }
            var e$5 = numFailed._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".numFailed" + e$5.path,
                      message: e$5.message,
                      value: e$5.value
                    }
                  };
          }
          var e$6 = numSucceeded._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".numSucceeded" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
        }
        var e$7 = afterNCommands._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".afterNCommands" + e$7.path,
                  message: e$7.message,
                  value: e$7.value
                }
              };
      }
      var e$8 = numCommands._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".numCommands" + e$8.path,
                message: e$8.message,
                value: e$8.value
              }
            };
    }
    var e$9 = trigger._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".trigger" + e$9.path,
              message: e$9.message,
              value: e$9.value
            }
          };
  }
  var e$10 = smartcutId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".smartcutId" + e$10.path,
            message: e$10.message,
            value: e$10.value
          }
        };
}

var TrackedPlaybackSetUserCancellation = {
  WithStringFields: WithStringFields$3,
  t_encode: t_encode$14,
  t_decode: t_decode$14
};

function preparePropertiesForSegment$12(param) {
  return {
          smartcutId: param.smartcutId,
          trigger: PlaybackTrigger$SmartcutsMacros.stringify(param.trigger),
          numCommands: param.numCommands,
          afterNCommands: param.afterNCommands,
          numSucceeded: param.numSucceeded,
          numFailed: param.numFailed,
          host: param.host,
          url: param.url,
          command: stringify$3(param.command),
          visibility: Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility),
          hasLoginSmartcut: param.hasLoginSmartcut
        };
}

function track$20(properties) {
  window.analytics.track("User Canceled Playback Set", preparePropertiesForSegment$12(properties));
  
}

var TrackUserCanceledPlaybackSet = {
  track: track$20
};

function track$21(properties) {
  window.analytics.track("Deleted Smartcut", properties);
  
}

var TrackDeleteSmartcut = {
  track: track$21
};

function preparePropertiesForSegment$13(param) {
  var failureReason = param.failureReason;
  var failedOnUrl = param.failedOnUrl;
  var tmp;
  if (typeof failureReason === "number" || failureReason.TAG !== /* FailWithOtherReason */0) {
    tmp = failedOnUrl;
  } else {
    var match = failureReason._0;
    tmp = typeof match === "number" || match.TAG !== /* FailWithElementNotFound */5 ? failedOnUrl : match._0;
  }
  return {
          smartcutId: param.smartcutId,
          trigger: PlaybackTrigger$SmartcutsMacros.stringify(param.trigger),
          numCommands: param.numCommands,
          failedAfterNCommands: param.failedAfterNCommands,
          failedIn: param.failedIn ? "ContentScriptMainFrame" : "BgScript",
          failedOnHost: param.failedOnHost,
          failedOnUrl: tmp,
          failedWithCommand: stringify$3(param.failedWithCommand),
          failureReason: Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.stringifyWithoutDetails, (function (otherReason) {
                  if (typeof otherReason === "number") {
                    switch (otherReason) {
                      case /* FailWithReceivingEndDoesNotExist */0 :
                          return "FailWithReceivingEndDoesNotExist";
                      case /* FailWithNoActiveTabToReceiveMessage */1 :
                          return "FailWithNoActiveTabToReceiveMessage";
                      case /* FailWithUserCancellation */2 :
                          return "FailWithUserCancellation";
                      case /* FailWithUserStopPlayback */3 :
                          return "FailWithUserStopPlayback";
                      case /* FailWithPlaybackDownloadNeverInitiated */4 :
                          return "FailWithPlaybackDownloadNeverInitiated";
                      case /* FailWithOAuthTokenNotGranted */5 :
                          return "FailWithOAuthTokenNotGranted";
                      case /* FailWithUnhandledException */6 :
                          return "FailWithUnhandledException";
                      case /* FailWithNoAvailableExecutions */7 :
                          return "FailWithNoAvailableExecutions";
                      
                    }
                  } else {
                    switch (otherReason.TAG | 0) {
                      case /* FailWithWebNavError */0 :
                          return "FailWithWebNavError";
                      case /* FailWithContentScriptFailure */1 :
                          return Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.stringifyWithoutDetails, ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason, otherReason._1);
                      case /* FailWithReceivedExtensionMessagingResponse */2 :
                          return "FailWithReceivedExtensionMessagingResponse";
                      case /* FailWithReceivedExtensionMessagingResponseFailureId */3 :
                          return "FailWithReceivedExtensionMessagingResponseFailureId";
                      case /* FailWithUserCloseLoginPage */4 :
                          return "FailWithUserCloseLoginPage";
                      case /* FailWithElementNotFound */5 :
                          return "FailWithElementNotFound";
                      case /* FailWithCannotCopyMissingSrcOfImg */6 :
                          return "FailWithCannotCopyMissingSrcOfImg";
                      case /* FailWithDocumentNotVisible */7 :
                          return "FailWithDocumentNotVisible";
                      case /* FailWithDocumentVisibilityUnknownOrUnloaded */8 :
                          return "FailWithDocumentVisibilityUnknownOrUnloaded";
                      case /* FailWithCdpUnableToGetDocument */9 :
                          return "FailWithCdpUnableToGetDocument";
                      case /* FailWithCdpUnableToGetContentQuads */10 :
                          return "FailWithCdpUnableToGetContentQuads";
                      case /* FailWithCouldNotApplySemantic */11 :
                          return "FailWithCouldNotApplySemantic";
                      case /* FailWithBlockingOverlay */12 :
                          return "FailWithBlockingOverlay";
                      case /* FailWithErrorWhileWaitForOverlayToUnblock */13 :
                          return "FailWithErrorWhileWaitForOverlayToUnblock";
                      case /* FailWithErrorWhileSearchForElement */14 :
                          return "FailWithErrorWhileSearchForElement";
                      case /* FailWithErrorWhileSearchViaCdpQuerySelector */15 :
                          return "FailWithErrorWhileSearchViaCdpQuerySelector";
                      case /* FailWithPlaybackCaptureScreenshotError */16 :
                          if (otherReason._0) {
                            return "FailWithPlaybackCaptureScreenshotError(CouldNotCaptureScreenshot)";
                          } else {
                            return "FailWithPlaybackCaptureScreenshotError(CouldNotGetBoxModel)";
                          }
                      case /* FailWithNoSwitchPredicateSatisfied */17 :
                          return "FailWithNoSwitchPredicateSatisfied";
                      case /* FailWithPermissionsRejected */18 :
                          return "FailWithPermissionsRejected";
                      case /* FailWithCommandStackInitError */19 :
                          return "FailWithCommandStackInitError";
                      case /* FailWithCommandStackRewindError */20 :
                          return "FailWithCommandStackRewindError";
                      
                    }
                  }
                }), failureReason),
          visibility: Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility),
          hasLoginSmartcut: param.hasLoginSmartcut
        };
}

function track$22(properties) {
  window.analytics.track("Smartcut Failure", preparePropertiesForSegment$13(properties));
  
}

var TrackSingleSmartcutExitFailure = {
  track: track$22
};

function preparePropertiesForSegment$14(param) {
  return {
          smartcutId: param.smartcutId,
          numPlaybacks: param.numPlaybacks,
          numCommands: param.numCommands,
          numParams: param.numParams,
          hosts: param.hosts,
          visibility: Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility),
          trigger: PlaybackTrigger$SmartcutsMacros.stringify(param.trigger),
          hasLoginSmartcut: param.hasLoginSmartcut
        };
}

function track$23(properties) {
  window.analytics.track("Start Smartcut Playback Set", preparePropertiesForSegment$14(properties));
  
}

var TrackStartPlaybackSet = {
  track: track$23
};

function preparePropertiesForSegment$15(param) {
  return {
          smartcutId: param.smartcutId,
          numPlaybacks: param.numPlaybacks,
          numSucceeded: param.numSucceeded,
          numFailed: param.numFailed,
          numCommands: param.numCommands,
          numParams: param.numParams,
          hosts: param.hosts,
          visibility: Curry._1(Smartcut$SmartcutsMacros.LoadedSmartcut.SmartcutVisibility.stringify, param.visibility),
          trigger: PlaybackTrigger$SmartcutsMacros.stringify(param.trigger),
          hasLoginSmartcut: param.hasLoginSmartcut
        };
}

function track$24(properties) {
  window.analytics.track("Finish Playback Set", preparePropertiesForSegment$15(properties));
  
}

var TrackFinishPlaybackSet = {
  track: track$24
};

function preparePropertiesForSegment$16(param) {
  return {
          remainingExecutions: param.remainingExecutions,
          context: Segment__TrackedQuotaWarning$SmartcutsMacros.QuotaWarningContext.stringify(param.context)
        };
}

function track$25(properties) {
  window.analytics.track("Warned about plan quota", preparePropertiesForSegment$16(properties));
  
}

var TrackQuotaWarning = {
  track: track$25
};

function preparePropertiesForSegment$17(param) {
  return {
          remainingExecutions: param.remainingExecutions,
          context: Segment__TrackedQuotaWarning$SmartcutsMacros.QuotaWarningContext.stringify(param.context)
        };
}

function track$26(properties) {
  window.analytics.track("Closed quota warning modal", preparePropertiesForSegment$17(properties));
  
}

var TrackCloseQuotaWarningModal = {
  track: track$26
};

function preparePropertiesForSegment$18(param) {
  return {
          remainingExecutions: param.remainingExecutions,
          context: Segment__TrackedQuotaWarning$SmartcutsMacros.QuotaWarningContext.stringify(param.context)
        };
}

function track$27(properties) {
  window.analytics.track("Adjusted playbacks after viewing quota warning modal", preparePropertiesForSegment$18(properties));
  
}

var TrackAdjustAndPlaybackAfterQuotaWarningModal = {
  track: track$27
};

function preparePropertiesForSegment$19(param) {
  return {
          remainingExecutions: param.remainingExecutions,
          context: Segment__TrackedQuotaWarning$SmartcutsMacros.QuotaWarningContext.stringify(param.context)
        };
}

function track$28(properties) {
  window.analytics.track("Clicked on View Plans", preparePropertiesForSegment$19(properties));
  
}

var TrackClickOnViewPlans = {
  track: track$28
};

function preparePropertiesForSegment$20(param) {
  return {
          remainingExecutions: param.remainingExecutions,
          context: Segment__TrackedQuotaWarning$SmartcutsMacros.QuotaWarningContext.stringify(param.context)
        };
}

function track$29(properties) {
  window.analytics.track("Went to Chrome Store Listing to Write Review", preparePropertiesForSegment$20(properties));
  
}

var TrackGoToChromeStorePageToWriteReview = {
  track: track$29
};

var WithStringProperties = {};

function t_encode$15(v) {
  return Js_dict.fromArray([
              [
                "smartcutId",
                SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
              ],
              [
                "installedSmartcutId",
                SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v.installedSmartcutId)
              ],
              [
                "origins",
                Decco.arrayToJson(Decco.stringToJson, v.origins)
              ],
              [
                "schedulePeriod",
                ScheduledTrigger$SmartcutsMacros.schedulePeriod_encode(v.schedulePeriod)
              ],
              [
                "doesUseCredentials",
                Decco.boolToJson(v.doesUseCredentials)
              ]
            ]);
}

function t_decode$15(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
  if (smartcutId.TAG === /* Ok */0) {
    var installedSmartcutId = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "installedSmartcutId"), null));
    if (installedSmartcutId.TAG === /* Ok */0) {
      var origins = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "origins"), null));
      if (origins.TAG === /* Ok */0) {
        var schedulePeriod = ScheduledTrigger$SmartcutsMacros.schedulePeriod_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "schedulePeriod"), null));
        if (schedulePeriod.TAG === /* Ok */0) {
          var doesUseCredentials = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "doesUseCredentials"), null));
          if (doesUseCredentials.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      smartcutId: smartcutId._0,
                      installedSmartcutId: installedSmartcutId._0,
                      origins: origins._0,
                      schedulePeriod: schedulePeriod._0,
                      doesUseCredentials: doesUseCredentials._0
                    }
                  };
          }
          var e = doesUseCredentials._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".doesUseCredentials" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = schedulePeriod._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".schedulePeriod" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = origins._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".origins" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = installedSmartcutId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".installedSmartcutId" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = smartcutId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".smartcutId" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function toWithStringProperties(param) {
  return {
          smartcutId: param.smartcutId,
          installedSmartcutId: param.installedSmartcutId,
          origins: param.origins,
          schedulePeriod: ScheduledTrigger$SmartcutsMacros.humanizeSchedulePeriod(param.schedulePeriod),
          doesUseCredentials: param.doesUseCredentials
        };
}

function stringify$6(param) {
  return "{ smartcutId: " + param.smartcutId + ", origins: [" + (param.origins.join(", ") + ("], schedulePeriod, doesUseCredentials: " + (Pervasives.string_of_bool(param.doesUseCredentials) + "}")));
}

var CreateScheduledTrigger = {
  WithStringProperties: WithStringProperties,
  t_encode: t_encode$15,
  t_decode: t_decode$15,
  toWithStringProperties: toWithStringProperties,
  stringify: stringify$6
};

function track$30(properties) {
  window.analytics.track("Created trigger", toWithStringProperties(properties));
  
}

var TrackCreateScheduledTrigger = {
  track: track$30
};

function track$31(properties) {
  window.analytics.track("Archived trigger", {
        triggerId: properties
      });
  
}

var TrackArchiveScheduledTrigger = {
  track: track$31
};

function trackUserAttemptToRenewFreePlan(param) {
  window.analytics.track("User attempt to renew free plan");
  
}

function trackUserSuccessfullyRenewedFreePlan(param) {
  window.analytics.track("User successfully renewed free plan");
  
}

function track$32(properties) {
  window.analytics.track("User failed to renew free plan", {
        failureInfo: properties
      });
  
}

var TrackUserFailedToRenewFreePlan = {
  track: track$32
};

function trackExtensionInit(param) {
  window.analytics.track("Extension initialized");
  
}

var WithStringProperties$1 = {};

function t_encode$16(v) {
  return Js_dict.fromArray([
              [
                "scheduledTriggerId",
                Decco.stringToJson(v.scheduledTriggerId)
              ],
              [
                "smartcutId",
                SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
              ],
              [
                "installedSmartcutId",
                SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v.installedSmartcutId)
              ],
              [
                "schedulePeriod",
                ScheduledTrigger$SmartcutsMacros.schedulePeriod_encode(v.schedulePeriod)
              ]
            ]);
}

function t_decode$16(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var scheduledTriggerId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "scheduledTriggerId"), null));
  if (scheduledTriggerId.TAG === /* Ok */0) {
    var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
    if (smartcutId.TAG === /* Ok */0) {
      var installedSmartcutId = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "installedSmartcutId"), null));
      if (installedSmartcutId.TAG === /* Ok */0) {
        var schedulePeriod = ScheduledTrigger$SmartcutsMacros.schedulePeriod_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "schedulePeriod"), null));
        if (schedulePeriod.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    scheduledTriggerId: scheduledTriggerId._0,
                    smartcutId: smartcutId._0,
                    installedSmartcutId: installedSmartcutId._0,
                    schedulePeriod: schedulePeriod._0
                  }
                };
        }
        var e = schedulePeriod._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".schedulePeriod" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = installedSmartcutId._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".installedSmartcutId" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = smartcutId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".smartcutId" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = scheduledTriggerId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".scheduledTriggerId" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

var ScheduledTriggerProps = {
  WithStringProperties: WithStringProperties$1,
  t_encode: t_encode$16,
  t_decode: t_decode$16
};

function preparePropertiesForSegment$21(param) {
  return {
          scheduledTriggerId: param.scheduledTriggerId,
          smartcutId: param.smartcutId,
          installedSmartcutId: param.installedSmartcutId,
          schedulePeriod: ScheduledTrigger$SmartcutsMacros.humanizeSchedulePeriod(param.schedulePeriod)
        };
}

function track$33(properties) {
  window.analytics.track("Cancelled scheduled playback", preparePropertiesForSegment$21(properties));
  
}

var TrackCancelScheduledPlayback = {
  track: track$33
};

var WithStringProperties$2 = {};

function t_encode$17(v) {
  return Js_dict.fromArray([
              [
                "smartcutId",
                SmartcutIds$SmartcutsMacros.smartcutId_encode(v.smartcutId)
              ],
              [
                "installedSmartcutId",
                SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v.installedSmartcutId)
              ],
              [
                "commandId",
                Decco.intToJson(v.commandId)
              ],
              [
                "urlWhenDetected",
                Decco.stringToJson(v.urlWhenDetected)
              ],
              [
                "loginUrl",
                Decco.stringToJson(v.loginUrl)
              ]
            ]);
}

function t_decode$17(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var smartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutId"), null));
  if (smartcutId.TAG === /* Ok */0) {
    var installedSmartcutId = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "installedSmartcutId"), null));
    if (installedSmartcutId.TAG === /* Ok */0) {
      var commandId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandId"), null));
      if (commandId.TAG === /* Ok */0) {
        var urlWhenDetected = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "urlWhenDetected"), null));
        if (urlWhenDetected.TAG === /* Ok */0) {
          var loginUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "loginUrl"), null));
          if (loginUrl.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      smartcutId: smartcutId._0,
                      installedSmartcutId: installedSmartcutId._0,
                      commandId: commandId._0,
                      urlWhenDetected: urlWhenDetected._0,
                      loginUrl: loginUrl._0
                    }
                  };
          }
          var e = loginUrl._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".loginUrl" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = urlWhenDetected._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".urlWhenDetected" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = commandId._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".commandId" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = installedSmartcutId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".installedSmartcutId" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = smartcutId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".smartcutId" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

var DetectedLoggedOutProps = {
  WithStringProperties: WithStringProperties$2,
  t_encode: t_encode$17,
  t_decode: t_decode$17
};

function preparePropertiesForSegment$22(param) {
  return {
          smartcutId: param.smartcutId,
          installedSmartcutId: param.installedSmartcutId,
          commandId: param.commandId,
          urlWhenDetected: param.urlWhenDetected,
          loginUrl: param.loginUrl
        };
}

function track$34(properties) {
  window.analytics.track("Detected logged out of website", preparePropertiesForSegment$22(properties));
  
}

var TrackDetectedUserLoggedOutOfWebsite = {
  track: track$34
};

function track$35(properties) {
  window.analytics.track("User did login to website", {
        loginUrl: properties
      });
  
}

var TrackUserDidLoginToWebsite = {
  track: track$35
};

function category_encode(v) {
  switch (v) {
    case /* DoesntWorkOnWebsites */0 :
        return ["DoesntWorkOnWebsites"];
    case /* DontKnowHowToUse */1 :
        return ["DontKnowHowToUse"];
    case /* DoesntHaveFeatureNeeded */2 :
        return ["DoesntHaveFeatureNeeded"];
    case /* RequiresPayment */3 :
        return ["RequiresPayment"];
    case /* SlowsDownMyComputer */4 :
        return ["SlowsDownMyComputer"];
    case /* InstallOnAnotherDevice */5 :
        return ["InstallOnAnotherDevice"];
    case /* OtherReason */6 :
        return ["OtherReason"];
    
  }
}

function category_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DoesntHaveFeatureNeeded" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DoesntHaveFeatureNeeded */2
                  };
          }
      case "DoesntWorkOnWebsites" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DoesntWorkOnWebsites */0
                  };
          }
      case "DontKnowHowToUse" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DontKnowHowToUse */1
                  };
          }
      case "InstallOnAnotherDevice" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* InstallOnAnotherDevice */5
                  };
          }
      case "OtherReason" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* OtherReason */6
                  };
          }
      case "RequiresPayment" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* RequiresPayment */3
                  };
          }
      case "SlowsDownMyComputer" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* SlowsDownMyComputer */4
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function displayCategory(category) {
  switch (category) {
    case /* DoesntWorkOnWebsites */0 :
        return "It doesn't work on websites";
    case /* DontKnowHowToUse */1 :
        return "I don't know how to use it";
    case /* DoesntHaveFeatureNeeded */2 :
        return "It doesn't have feature(s) I needed";
    case /* RequiresPayment */3 :
        return "I don't like it requires payments/It's too expensive";
    case /* SlowsDownMyComputer */4 :
        return "It slows down my computer";
    case /* InstallOnAnotherDevice */5 :
        return "I have installed/will install Smartcuts on my other computers";
    case /* OtherReason */6 :
        return "Other reasons";
    
  }
}

var ForOrigTrack = {};

function forOrigTrack(props) {
  var arg = props.category;
  var category = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
      })("Expect some reason for uninstalling)");
  var extraInfo;
  switch (category) {
    case /* DoesntWorkOnWebsites */0 :
        extraInfo = Belt_Option.map(props.extraInfo.doesntWorkOnWebsites, (function (v) {
                if (v.TAG === /* FromInstalledSmartcuts */0) {
                  return v._0.join(", ");
                } else {
                  return v._0;
                }
              }));
        break;
    case /* DoesntHaveFeatureNeeded */2 :
        extraInfo = props.extraInfo.doesntHaveFeatureNeeded;
        break;
    case /* DontKnowHowToUse */1 :
    case /* RequiresPayment */3 :
    case /* SlowsDownMyComputer */4 :
    case /* InstallOnAnotherDevice */5 :
        extraInfo = undefined;
        break;
    case /* OtherReason */6 :
        extraInfo = props.extraInfo.otherReason;
        break;
    
  }
  return {
          category: displayCategory(category),
          extraInfo: extraInfo
        };
}

var ReasonForUninstalling = {
  category_encode: category_encode,
  category_decode: category_decode,
  displayCategory: displayCategory,
  ForOrigTrack: ForOrigTrack,
  forOrigTrack: forOrigTrack
};

function track$36(properties) {
  window.analytics.track("User selected reason for uninstalling", forOrigTrack(properties));
  
}

var TrackUserSelectReasonForUninstalling = {
  track: track$36
};

function preparePropertiesForSegment$23(propertiesForTrack) {
  return {
          reason: forOrigTrack(propertiesForTrack.reason),
          feedback: propertiesForTrack.feedback
        };
}

function track$37(properties) {
  window.analytics.track("User submitted post-uninstall survey", preparePropertiesForSegment$23(properties));
  
}

var TrackUserSubmitUninstallSurvey = {
  track: track$37
};

function credentialType_encode(v) {
  if (v) {
    return [
            "OAuthVia",
            OAuthProvider$SmartcutsMacros.t_encode(v._0)
          ];
  } else {
    return ["Password"];
  }
}

function credentialType_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "OAuthVia" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = OAuthProvider$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* OAuthVia */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Password" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Password */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function credentialTypeToString(credentialType) {
  if (credentialType) {
    return "OAuth via " + OAuthProvider$SmartcutsMacros.stringify(credentialType._0);
  } else {
    return "Password";
  }
}

function preparePropertiesForSegment$24(param) {
  return {
          hostname: param.hostname,
          credentialType: credentialTypeToString(param.credentialType)
        };
}

function track$38(properties) {
  window.analytics.track("User added credential", preparePropertiesForSegment$24(properties));
  
}

var TrackUserAddedCredential = {
  track: track$38
};

function preparePropertiesForSegment$25(param) {
  return {
          hostname: param.hostname,
          credentialType: credentialTypeToString(param.credentialType)
        };
}

function track$39(properties) {
  window.analytics.track("User removed credential", preparePropertiesForSegment$25(properties));
  
}

var TrackUserRemovedCredential = {
  track: track$39
};

var TrackedUserClickOnRecordLoginSmartcut = {};

function track$40(properties) {
  window.analytics.track("Click on record new login smartcut", properties);
  
}

var TrackUserClickOnRecordNewLoginSmartcut = {
  track: track$40
};

var TrackedUserRemoveLoginSmartcut = {};

function track$41(properties) {
  window.analytics.track("Click on remove login smartcut", properties);
  
}

var TrackUserClickOnRemoveLoginSmartcut = {
  track: track$41
};

function track$42(properties) {
  window.analytics.track("Did remove login smartcut", properties);
  
}

var TrackUserDidDetachLoginSmartcut = {
  track: track$42
};

exports.exists = exists;
exports.MakeTrackerForEventWithProperties = MakeTrackerForEventWithProperties;
exports.TrackedInstallableSmartcutProps = TrackedInstallableSmartcutProps;
exports.TrackedInstalledSmartcutProps = TrackedInstalledSmartcutProps;
exports.TrackedVisitingFromDevice = TrackedVisitingFromDevice;
exports.TrackVisitingFromDevice = TrackVisitingFromDevice;
exports.trackVisitingFromDevice = trackVisitingFromDevice;
exports.TrackedSchedulingSmartcutProps = TrackedSchedulingSmartcutProps;
exports.TrackViewInstallableSmartcut = TrackViewInstallableSmartcut;
exports.trackAttemptAcceptInvite = trackAttemptAcceptInvite;
exports.trackAcceptedInvite = trackAcceptedInvite;
exports.TrackFailedAttemptToAcceptInvite = TrackFailedAttemptToAcceptInvite;
exports.trackAttemptSetPassword = trackAttemptSetPassword;
exports.trackSetPassword = trackSetPassword;
exports.TrackFailedAttemptToSetPassword = TrackFailedAttemptToSetPassword;
exports.trackUserForgotPassword = trackUserForgotPassword;
exports.trackChromeExtensionDownloadAttempt = trackChromeExtensionDownloadAttempt;
exports.TrackChromeExtensionInstall = TrackChromeExtensionInstall;
exports.TrackChromeExtensionUninstall = TrackChromeExtensionUninstall;
exports.TrackChromeExtensionUpdate = TrackChromeExtensionUpdate;
exports.trackChromeUpdate = trackChromeUpdate;
exports.trackChromeSharedModuleUpdate = trackChromeSharedModuleUpdate;
exports.TrackedPermissionsRejection = TrackedPermissionsRejection;
exports.TrackedPermissionsRejectionWithStringReason = TrackedPermissionsRejectionWithStringReason;
exports.TrackRejectPermissions = TrackRejectPermissions;
exports.TrackedViewOauthExplanationModal = TrackedViewOauthExplanationModal;
exports.TrackViewOauthExplanationModal = TrackViewOauthExplanationModal;
exports.trackCancelOAuthExplanationModal = trackCancelOAuthExplanationModal;
exports.trackInitiateOAuthConsentFlow = trackInitiateOAuthConsentFlow;
exports.trackOAuthConsentGranted = trackOAuthConsentGranted;
exports.trackOAuthConsentRejected = trackOAuthConsentRejected;
exports.TrackedStartRecording = TrackedStartRecording;
exports.TrackStartedRecording = TrackStartedRecording;
exports.finalSmartcutRecordingProps_encode = finalSmartcutRecordingProps_encode;
exports.finalSmartcutRecordingProps_decode = finalSmartcutRecordingProps_decode;
exports.finalSmartcutProps_encode = finalSmartcutProps_encode;
exports.finalSmartcutProps_decode = finalSmartcutProps_decode;
exports.TrackAttemptedStopRecording = TrackAttemptedStopRecording;
exports.TrackFinishedAuthoringSmartcut = TrackFinishedAuthoringSmartcut;
exports.TrackInterestedInInstallingSmartcut = TrackInterestedInInstallingSmartcut;
exports.TrackAttemptInstallSmartcut = TrackAttemptInstallSmartcut;
exports.trackUserAttemptToContactSupport = trackUserAttemptToContactSupport;
exports.PageOnboardingSpecified = PageOnboardingSpecified;
exports.TrackBeginAutoInstallSmartcut = TrackBeginAutoInstallSmartcut;
exports.TrackInstallSmartcutSuccess = TrackInstallSmartcutSuccess;
exports.TrackInstallSmartcutFailed = TrackInstallSmartcutFailed;
exports.finalSmartcutPropsWithId_encode = finalSmartcutPropsWithId_encode;
exports.finalSmartcutPropsWithId_decode = finalSmartcutPropsWithId_decode;
exports.TrackedPermissionEventProps = TrackedPermissionEventProps;
exports.TrackAboutToExplainPermission = TrackAboutToExplainPermission;
exports.TrackPermissionGrant = TrackPermissionGrant;
exports.TrackPermissionDeny = TrackPermissionDeny;
exports.TrackedStartPlaybackSet = TrackedStartPlaybackSet;
exports.TrackedFinishPlaybackSet = TrackedFinishPlaybackSet;
exports.TrackedCommand = TrackedCommand;
exports.TrackedPlaybackFailure = TrackedPlaybackFailure;
exports.TrackedPlaybackSetUserCancellation = TrackedPlaybackSetUserCancellation;
exports.TrackUserCanceledPlaybackSet = TrackUserCanceledPlaybackSet;
exports.TrackDeleteSmartcut = TrackDeleteSmartcut;
exports.TrackSingleSmartcutExitFailure = TrackSingleSmartcutExitFailure;
exports.TrackStartPlaybackSet = TrackStartPlaybackSet;
exports.TrackFinishPlaybackSet = TrackFinishPlaybackSet;
exports.TrackQuotaWarning = TrackQuotaWarning;
exports.TrackCloseQuotaWarningModal = TrackCloseQuotaWarningModal;
exports.TrackAdjustAndPlaybackAfterQuotaWarningModal = TrackAdjustAndPlaybackAfterQuotaWarningModal;
exports.TrackClickOnViewPlans = TrackClickOnViewPlans;
exports.TrackGoToChromeStorePageToWriteReview = TrackGoToChromeStorePageToWriteReview;
exports.CreateScheduledTrigger = CreateScheduledTrigger;
exports.TrackCreateScheduledTrigger = TrackCreateScheduledTrigger;
exports.TrackArchiveScheduledTrigger = TrackArchiveScheduledTrigger;
exports.trackUserAttemptToRenewFreePlan = trackUserAttemptToRenewFreePlan;
exports.trackUserSuccessfullyRenewedFreePlan = trackUserSuccessfullyRenewedFreePlan;
exports.TrackUserFailedToRenewFreePlan = TrackUserFailedToRenewFreePlan;
exports.trackExtensionInit = trackExtensionInit;
exports.ScheduledTriggerProps = ScheduledTriggerProps;
exports.TrackCancelScheduledPlayback = TrackCancelScheduledPlayback;
exports.DetectedLoggedOutProps = DetectedLoggedOutProps;
exports.TrackDetectedUserLoggedOutOfWebsite = TrackDetectedUserLoggedOutOfWebsite;
exports.TrackUserDidLoginToWebsite = TrackUserDidLoginToWebsite;
exports.ReasonForUninstalling = ReasonForUninstalling;
exports.TrackUserSelectReasonForUninstalling = TrackUserSelectReasonForUninstalling;
exports.TrackUserSubmitUninstallSurvey = TrackUserSubmitUninstallSurvey;
exports.credentialType_encode = credentialType_encode;
exports.credentialType_decode = credentialType_decode;
exports.credentialTypeToString = credentialTypeToString;
exports.TrackUserAddedCredential = TrackUserAddedCredential;
exports.TrackUserRemovedCredential = TrackUserRemovedCredential;
exports.TrackedUserClickOnRecordLoginSmartcut = TrackedUserClickOnRecordLoginSmartcut;
exports.TrackUserClickOnRecordNewLoginSmartcut = TrackUserClickOnRecordNewLoginSmartcut;
exports.TrackedUserRemoveLoginSmartcut = TrackedUserRemoveLoginSmartcut;
exports.TrackUserClickOnRemoveLoginSmartcut = TrackUserClickOnRemoveLoginSmartcut;
exports.TrackUserDidDetachLoginSmartcut = TrackUserDidDetachLoginSmartcut;
/* Smartcut-SmartcutsMacros Not a pure module */
